import React from 'react'
import { Card, Table, Pagination } from 'antd'
import datatable from '../../../utils/tableData'
import ServerApi from '../../../utils/ServerApi'
import appConst from '../../../constents/app.const'
import api_url from '../../../utils/requestApi'

class WorkHistroy extends React.Component{
    constructor(props){
        super(props)
        this.tableDataFetch = this.tableDataFetch.bind(this)
    }
    state={
        tableData: [],
        empty: true,
        loading: false,
        current_page: 1,
        page_size: 12,
        page_size_default: 12,
        total_page: 1
    }
    componentDidMount(){
        this.tableDataFetch()
    }
    tableDataFetch(current_page = this.state.current_page){
        let serverApi = new ServerApi(appConst.apiUrl, this.props.token);
        this.setState({loading: true}, () => {
            serverApi.deposit_history(api_url.work_history+current_page+'/'+this.state.page_size, (returnData) => {
                if(returnData.success == 1){
                    this.setState({
                        empty: false,
                        tableData: this.processData(returnData.data),
                        current_page: returnData.current_page,
                        total_page: returnData.total_page,
                        page_size: returnData.limit,
                    })
                }else{
                    this.setState({
                        empty: true
                    })
                }
                this.setState({loading: false})
            })
        })
    }
    
    processData = (response) => {
        response.map((obj, i) => {
            obj.key = i;
            obj.serial = this.state.current_page == 1 ? i+1 : ((this.state.current_page - 1) * this.state.page_size) + i + 1;
            obj.time = obj.time.replace(' ', '_');
            obj.actionAt = obj.actionAt.replace(' ', '_');
            obj.match = obj.A_team + '_vs_' + obj.B_team + ' ' + obj.title;
            obj.option = obj.matchTitle;
            // obj.target = obj.betTitle;
            if (obj.autoNo == 0 || (obj.autoNo == null && obj.under == null)) {
                obj.target = obj.betTitle
            } else if (obj.autoNo == 6) {
                obj.target = ((obj.run == 0) ? '0' : obj.run - 0.5) + ' ' + obj.betTitle + ' ' + ((obj.run2 == 0) ? '0' : obj.run2 - 0.5)
            } else if (obj.autoNo == 5) {
                obj.target = obj.run + ' ' + obj.betTitle + ' ' + ((obj.run2 == 0) ? '0' : obj.run2 - 0.5)
            } else if (obj.autoNo == 7) {
                obj.target = ((obj.run == 0) ? '0' : obj.run - 0.5) + ' ' + obj.betTitle
            } else if (obj.autoNo == 2 || obj.autoNo == 3) {
                if (obj.under == 5) {
                    obj.target = obj.run + ' ' + obj.betTitle + ' ' + ((obj.run2 == 0) ? '0' : obj.run2 - 0.5)
                } else if (obj.under == 8) {
                    obj.target = ((obj.run == 0) ? '0' : obj.run - 0.5) + ' ' + obj.betTitle
                } else {
                    obj.target = ((obj.run == 0) ? '0' : obj.run - 0.5) + ' ' + obj.betTitle + ' ' + ((obj.run2 == 0) ? '0' : obj.run2 - 0.5)
                }
            } else {
                obj.target = obj.run + ' ' + obj.betTitle
            }
            obj.return = (obj.betAmount * obj.betRate).toFixed(2);
            if(obj.work == 1){
                obj.work = 'Football';
            }else if(obj.work == 2){
                obj.work = 'Cricket';
            }else if(obj.work == 4){
                obj.work = 'Tennis';
            }else if(obj.work == 5){
                obj.work = 'Table Tannis';
            }
            if(obj.action == 0 && obj.betStatus == 0){
                obj.status = <span style={{color: '#8B8B05'}}>Pending</span>;
            }else if(obj.action == 0 && obj.betStatus == 1){
                obj.status = <span style={{color: 'green'}}>Win</span>;
            }else if(obj.action == 0 && obj.betStatus == 2){
                obj.status = <span style={{color: 'red'}}>Loss</span>;
            }else if(obj.action == 2){
                obj.status = <span style={{color: '#8E0909'}}>Partial Return</span>;
            }else if(obj.action == 3){
                obj.status = <span style={{color: '#8E0909'}}>Partial Send</span>;
            }else if(obj.action == 1){
                obj.status = <span style={{color: '#8E0909'}}>Void</span>;
            }
        })
        return response;
    }
    render(){
        return(
            <Card>
                <u className="ml-5"><h5>Work History</h5></u>
                <div className="table-container">
                    <Table
                        loading={this.state.loading}
                        bordered={true}
                        tableLayout="auto"
                        size="small"
                        dataSource={this.state.tableData}
                        pagination={false}
                        columns={datatable.work}
                    />
                    <div style={{marginTop:"10px",float:"right"}}>
                        <Pagination 
                            size="small"
                            defaultCurrent={this.state.current_page}
                            current={this.state.current_page}
                            pageSize={this.state.page_size_default}
                            total={this.state.total_page}
                            onChange={(page) => {
                                this.setState({current_page: page}, () => {
                                    this.tableDataFetch()
                                })
                            }}
                        />
                    </div>
                </div>
            </Card>
        )
    }
}

export default WorkHistroy;